export default {
  shipped: {
    en: 'Shipped',
  },
  skipped: {
    en: 'Skipped',
  },
  locked: {
    en: 'Processing',
  },
  paused: {
    en: 'Paused',
  },
  trackingNumber: {
    en: 'Tracking number',
  },
}
